import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ConfirmationModal from '../common/ConfirmationModal';
import { removeApp } from '../common/appStatusActionCreators';
import { closeRemove } from './appRemoveActionCreators';

function AppRemove(props) {
    const remove = () => {
        props.dispatchRemoveApp(props.appId);
        props.dispatchCloseRemove();
    };

    return (
        <ConfirmationModal
            className="AppRemove"
            closeHandler={props.dispatchCloseRemove}
            header={`Remove ${props.name}`}
            confirmHandler={remove}
            confirmLabel="Remove"
        >
            <p>Do you really want to remove this Add-On?</p>
        </ConfirmationModal>
    );
}

AppRemove.propTypes = {
    appId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    dispatchCloseRemove: PropTypes.func.isRequired,
    dispatchRemoveApp: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchCloseRemove: closeRemove,
    dispatchRemoveApp: removeApp,
};

// thanks to AppRemoveWrapper we can use
// componentWillMount and componentWillUnmount in AppRemove
function AppRemoveWrapper(props) {
    return props.appId ? <AppRemove {...props} /> : null;
}

AppRemoveWrapper.propTypes = {
    appId: PropTypes.string,
};

export default connect((state) => state.appRemove, mapDispatchToProps)(AppRemoveWrapper);
